import { singletonFactory } from '@warehouse/shared/util';

export class HostServiceImpl {
	getHostname(): string {
		return window.location.hostname;
	}
}

export const hostServiceSingleton = singletonFactory<HostServiceImpl>({
	factory: () => new HostServiceImpl(),
});
